import { createAction } from 'redux-actions';

import { ADMIN_LOAD_STARTED, ADMIN_LOAD_DONE } from '../actions';

export const adminLoadStarted = createAction(ADMIN_LOAD_STARTED);
export const adminLoadDone = createAction(ADMIN_LOAD_DONE);
